export async function sendVerificationCode(email) {
    const response = await fetch(`${process.env.VUE_APP_URL_DEV}/api/email/send-verification-code`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            'email': email
        })
    });
    return response.ok;
}

export async function verifyCode(email, code) {
    const response = await fetch(`${process.env.VUE_APP_URL_DEV}/api/email/verify-code`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            'email': email,
            'code': code
        })
    });
    return response.ok;
}